import axios from 'axios';

const baseUrl = window.config.API_URL;

const updatingHeading = async (data) => {
  const token = JSON.parse(localStorage.getItem('user'))?.token;
  const userID = JSON.parse(localStorage.getItem('user'))?.userid;
  const optionId = data?.optionId;
  const headingData = {
    coloum_value: data?.coloum_value,
    coloum_type: data?.coloum_type,
    coloum_name: data?.coloum_name,
    stateColor: data?.stateColor,
  };
  const path = `/api/user/updateBlock/${optionId}/${userID}/${token}`;
  const url = baseUrl + path;
  const response = await axios.put(url, headingData);
  return response.data;
};

// _______________________Upating AvatarCard______________

const updatingAvatarCard = async (data) => {
  const token = JSON.parse(localStorage.getItem('user'))?.token;
  const userID = JSON.parse(localStorage.getItem('user'))?.userid;
  const optionId = data?.optionId;
  const avatarData = {
    coloum_name: data?.coloum_name,
    coloum_type: data?.coloum_type,
    color: data?.colorState,
    borderWidthState: data?.borderWidthState,
    borderStyleState: data?.borderStyleState,
    radius: data?.avtarRadius,
    size: data?.avtarSize,
    picture: data.picture,
    optionId: data.optionId,
    userid: userID,
  };
  // const postAvatarData = JSON.stringify(avatarData)
  const path = `/api/user/updateAvatarBlock`;
  const url = baseUrl + path;
  // const response = await axios.put(url, avatarData)
  const response = await axios.put(url, avatarData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `'Bearer'${token}`,
    },
  });
  return response.data;
};

const updatingSocialCard = async (data) => {
  const token = JSON.parse(localStorage.getItem('user'))?.token;
  const userID = JSON.parse(localStorage.getItem('user'))?.userid;
  const postdata = {
    columnName: data.columnName,
    colorState: data.colorState,
    sizeState: data.sizeState,
    emailState: data.emailState,
    phoneState: data.phoneState,
    facebookState: data?.facebookState,
    massengerState: data?.massengerState,
    instagramState: data?.instagramState,
    twitterState: data?.twitterState,
    tiktokState: data?.tiktokState,
    youtubeState: data?.youtubeState,
    soundcloudState: data?.soundcloudState,
    linkedinState: data?.linkedinState,
    spotifyState: data?.spotifyState,
    pinterestState: data?.pinterestState,
    twitchState: data?.twitchState,
    discordState: data?.discordState,
    snapchatState: data?.snapchatState,
    telegramState: data?.telegramState,
    userID,
    optionid: data.optionid,
  };
  const path = `/api/user/updateSocialBlock`;
  const url = baseUrl + path;
  const response = await axios.put(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `'Bearer'${token}`,
    },
    data: postdata,
  });
  return response.data;
};

const updatingLinkCard = async (data) => {
  const token = JSON.parse(localStorage.getItem('user'))?.token;
  const userID = JSON.parse(localStorage.getItem('user'))?.userid;
  const optionId = data?.optionId;
  const headingData = {
    animationStylesArray: data?.animationStylesArray,
    animationRunsArray: data?.animationRunsArray,
    bgcolorState: data?.bgcolorState,
    borderWidthState: data?.borderWidthState,
    textcolorState: data?.textcolorState,
    textIcon: data?.textIcon,
    bordercolorState: data?.bordercolorState,
    coloum_value: data?.coloum_value,
    picture: data?.picture,
    coloum_type: data?.coloum_type,
    coloum_name: data?.coloum_name,
    borderRadiusState: data?.borderRadiusState,
    borderStyleState: data?.borderStyleState,
  };

  const path = `/api/user/updateLinkBlock/${optionId}/${userID}/${token}`;
  const url = baseUrl + path;
  const response = await axios.put(url, headingData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `'Bearer'${token}`,
    },
  });

  return response.data;
};

const updatingFaqCard = async (state) => {
  const linkId = localStorage.getItem('linkId');
  const userID = JSON.parse(localStorage.getItem('user')).userid;

  console.log('state', state);

  const faqData = [];

  if (state?.title_one || state?.description_one) {
    faqData.push({ title: state?.title_one, description: state?.description_one });
  }
  if (state?.title_two || state?.description_two) {
    faqData.push({ title: state?.title_two, description: state?.description_two });
  }
  if (state?.title_three || state?.description_three) {
    faqData.push({ title: state?.title_three, description: state?.description_three });
  }

  const coloumnValue = faqData;
  const coloumnType = state?.coloum_type || null;
  const columnName = state?.columnName;
  const optionId = state?.optionId;

  const data = {
    columnName,
    coloumnType,
    coloumnValue,
    linkId,
    userID,
    optionId,
  };
  // const postData = JSON.stringify(data);
  const path = `/api/user/updateFaqBlock`;
  const url = baseUrl + path;
  const response = await axios.post(url, data);

  return response.data;
};

const updatingYoutubeCard = async () => {};
const updatingTwitterCard = async () => {};
const updatingInstagramCard = async () => {};
const cardsService = {
  updatingHeading,
  updatingAvatarCard,
  updatingSocialCard,
  updatingLinkCard,
  updatingYoutubeCard,
  updatingTwitterCard,
  updatingInstagramCard,
  updatingFaqCard,
};
export default cardsService;
